import { colors, RISK_COLORS } from '@lmc/common/constants'
import { Text } from '@lmc/ui-kit'
import type { CSSProperties, FC } from 'react'

interface RiskValueProps {
  risk?: string
  value?: number
}

const RiskValue: FC<RiskValueProps> = ({ risk, value }) => {
  if ((!risk || !value) && value !== 0) return null

  return (
    <div
      style={
        {
          ...styles.riskContainer,
          // @ts-ignore
          background: RISK_COLORS[risk] || colors.darkgrey
        } as CSSProperties
      }
    >
      <Text
        style={{
          ...styles.risk,
          fontSize: riskValueLength(value) > 2 ? 11 : 13
        }}
      >
        {value || 0}
      </Text>
    </div>
  )
}

const riskValueLength = (value: number): number => value.toString().length

const styles = {
  risk: {
    color: 'white',
    fontSize: 13,
    marginLeft: 1
  },
  riskContainer: {
    borderRadius: 4,
    display: 'flex',
    flexShrink: 0,
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 10,
    height: 25,
    width: 25,
    userSelect: 'none'
  }
}

export default RiskValue
